export type getInfoRequestType = {
  partner: string;
  local: string;
};

export type getInfoResponseType<T> = {
  code?: number;
  success: boolean;
  message: string;
  data: T;
};

export type partnerElementDataType = {
  id: number;
  name: string | null;
  buttons?: partnerItemType[];
  cards?: partnerElementCardType[];
  texts?: partnerItemType[];
  images?: partnerItemType[];
};
export type partnerElementCardType = {
  id: number;
  order: number;
  attribues?: string;
  buttons?: partnerItemType[];
  cards?: partnerElementCardType[];
  texts?: partnerItemType[];
  images?: partnerItemType[];
  button?: partnerItemType;
};
export interface partnerItemType {
  id: number;
  order: number;
  attribues?: string;
  content_fr?: string;
  content_en?: string;
  type: typeElement;
  url_fr?: string;
  url_en?: string;
  content?: partnerItemContent;
  action?: string;
  redirect_url?: string;
}
interface partnerItemContent {
  id: number;
  order: number;
  attribues?: string;
  content_fr?: string;
  content_en?: string;
  type: typeElement;
}
export type apiData = {
  type: typeElement;
  order?: number;
  content_fr: string;
  content_en: string;
};
export enum AttributesHtmlElement {
  primary = "PRIMARY",
  danger = "DANGER",
  warning = "WARNING",
  iconButton = "ICONBUTTON",
  success = "SUCCESS",
  white = "WHITE",
  declarative = "DECLARATIVE",
  black = "BLACK"
}
export enum typeElement {
  STEP = "STEP",
  DESCRIPTION = "DESCRIPTION",
  TITLE = "TITLE",
  BACKGROUND = "BACKGROUND",
  LOGO = "LOGO",
  BANNER = "BANNER",
  BUTTON = "BUTTON",
  CARD_BUTTON = "CARD_BUTTON",
  HTML_STEP = "HTML_STEP",
  FOOTER = "FOOTER",
  FOOTER_INFO = "FOOTER_INFO",
  HTML_TITLE = "HTML_TITLE",
  HTML_TERM = "HTML_TERM"
}

export enum buttonAction {
  PARTICIPATE = "PARTICIPATE",
  CREATE_ACCOUNT = "CREATE_ACCOUNT",
  READMORE = "READ_MORE",
  REDIRECT = "REDIRECT"
}
